<template>
    <div class="cz3__progress-bar">
        <div class="cz3__progress-bar__filled"
            :style="{
                width: progressPercentage,
            }"
        >
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__progress-bar {
            flex: 0 0 auto;

            position: relative;

            width: 100%;
            height: 8px;

            background: #f3f3f3;

            @include respond-above(sm) {
                height: 4px;

                background: #f3f3f3;
            }
        }

        .cz3__progress-bar__filled {
            position: absolute;

            left: 0;
            top: 0;

            height: 100%;

            background: #000;

            transition: width 0.25s ease-out;
        }
    }
</style>

<script>
    export default {
        computed: {
            selectedStep() {
                return this.$store.state.selectedStepV3;
            },

            totalColors() {
                return this.$store.getters.availablePrintingColorsV3.length + this.$store.getters.availableEtchingColorsV3.length;
            },

            hasColors() {
                return this.totalColors > 1;
            },

            totalSides() {
                return this.$store.getters.availableSidesV3;
            },

            totalSteps() {
                // Start.
                let steps = 1;

                if (this.totalColors > 1) {
                    steps += 1;
                }

                steps += this.totalSides.length;

                // Review.
                steps += 1;

                // Undo some steps, such as start.
                steps -= this.offset;

                return steps;
            },

            offset() {
                return 1;
            },

            progress() {
                if (this.selectedStep === 'start') {
                    return 1 - this.offset;
                }

                if (this.selectedStep === 'itemColors') {
                    return 2 - this.offset;
                }

                const step = (this.hasColors ? 2 : 1) - this.offset;

                if (this.selectedStep === 'design-1') {
                    return step + 1;
                }

                if (this.selectedStep === 'design-1-1') {
                    return step + 2;
                }

                if (this.selectedStep === 'design-2') {
                    return step + 3;
                }

                if (this.selectedStep === 'design-2-1') {
                    return step + 4;
                }

                if (this.selectedStep === 'design-3') {
                    return step + 5;
                }

                if (this.selectedStep === 'design-3-1') {
                    return step + 6;
                }

                if (this.selectedStep === 'review') {
                    return this.totalSteps;
                }

                return this.totalSteps;
            },

            progressPercentage() {
                return `${((this.progress / this.totalSteps) * 100).toFixed(2)}%`;
            },
        },
    };
</script>
